export default "__VITE_ASSET__DGabgIFl__"